/**
 * Version Configuration
 *
 * Centralized version information for the application.
 * Import this file to access version data throughout the app.
 *
 * Usage:
 * import { VERSION, PHASE, FULL_VERSION } from './config/version';
 * import version from './config/version'; // default export
 */
export const VERSION = '1.12.229-beta';
export const PHASE = 'Phase 1a';
export const BUILD_DATE = '2026-11-03'; // Refreshed for 1.12.229-beta.
export const FULL_VERSION = `v1.12.229-beta, Phase 1a`;
// Default export with all version info
const version = {
    VERSION,
    PHASE,
    BUILD_DATE,
    FULL_VERSION
};
export default version;
